import { Modal, Spin } from 'antd';
import { Suspense, lazy } from 'react';

const PdfViewer = lazy(() => import('./pdf-viewer'));

export const isPdfFile = (f) => (f.contentType ?? '').toLowerCase() === 'application/pdf'
    || (f.name ?? '').toLowerCase().endsWith('.pdf');

const PdfModal = ({ file, onClose }) => (
    <Modal
        open={!!file}
        title={file?.name}
        footer={null}
        width="min(1000px, 96vw)"
        centered
        destroyOnClose
        onCancel={onClose}
    >
        {file && (
            <Suspense fallback={<Spin />}>
                <PdfViewer file={file} />
            </Suspense>
        )}
    </Modal>
);

export default PdfModal;
